import React from 'react';

const OrderHistoryModal = ({ 
  showTracker, 
  setShowTracker, 
  ongoingOrders, 
  completedOrders, 
  onClearAllRecords 
}) => {
  if (!showTracker) return null;

  return (
    <div style={{ 
      position: "fixed", 
      bottom: "105px", 
      left: "15px", 
      right: "15px", 
      zIndex: 1000, 
      background: "white", 
      border: "4px solid black", 
      borderRadius: "10px", 
      boxShadow: "8px 8px 0 rgba(0,0,0,1)", 
      display: "flex", 
      flexDirection: "column", 
      maxHeight: "65vh", 
      overflow: "hidden" 
    }}>
      <div style={{ 
        background: "#f0f0f0", 
        padding: "15px", 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center", 
        borderBottom: "3px solid black" 
      }}>
        <span style={{ fontWeight: "900", fontSize: "18px" }}>📜 我的订单档案</span>
        <button 
          onClick={() => setShowTracker(false)} 
          style={{ 
            background: "black", 
            color: "white", 
            border: "none", 
            padding: "5px 10px", 
            fontWeight: "bold", 
            borderRadius: "5px" 
          }}
        >
          关闭 ⬇
        </button>
      </div>
      
      <div style={{ 
        padding: "15px", 
        overflowY: "auto", 
        flex: 1, 
        background: "#fafafa" 
      }}>
        {/* 🔥 进行中订单区域 */}
        {ongoingOrders.length > 0 && (
          <>
            <div style={{ 
              fontWeight: "900", 
              fontSize: "16px", 
              marginBottom: "10px", 
              borderBottom: "2px solid #ccc", 
              paddingBottom: "5px" 
            }}>
              🔥 进行中 ({ongoingOrders.length})
            </div>
            {ongoingOrders.slice().reverse().map(order => (
              <div key={order.id} style={{ 
                border: "3px solid black", 
                background: "white", 
                padding: "15px", 
                marginBottom: "15px", 
                boxShadow: "3px 3px 0 #000", 
                position: "relative" 
              }}>
                <div style={{ 
                  position: "absolute", 
                  top: "-12px", 
                  right: "-10px", 
                  background: order.status === 'DONE' ? "#4CAF50" : order.status === 'MAKING' ? "#E6B422" : "#ccc", 
                  color: order.status === 'DONE' ? "white" : "black", 
                  padding: "4px 12px", 
                  fontWeight: "900", 
                  border: "2px solid black", 
                  transform: "rotate(5deg)" 
                }}>
                  {order.status === 'DONE' ? '✅ 可取餐' : order.status === 'MAKING' ? '🔥 制作中' : '🕒 待处理'}
                </div>
                <div style={{ fontWeight: "900", fontSize: "16px", marginBottom: "8px" }}>
                  单号：#{order.id}
                </div>
                <div style={{ 
                  fontSize: "13px", 
                  color: "#444", 
                  borderTop: "1px dashed #ccc", 
                  paddingTop: "8px", 
                  paddingBottom: "8px" 
                }}>
                  {order.items ? JSON.parse(order.items).map((item, i) => (
                    <div key={i}>
                      • {item.name} x {item.quantity} 
                      {item.customization !== "标准配方" && (
                        <span style={{color:"#ff5252"}}>({item.customization})</span>
                      )}
                    </div>
                  )) : "产品明细加载中..."}
                </div>
                <div style={{ 
                  textAlign: "right", 
                  fontWeight: "900", 
                  fontSize: "18px", 
                  color: "#E85A33" 
                }}>
                  ¥{order.total_amount}
                </div>
              </div>
            ))}
          </>
        )}

        {/* 🗄️ 历史归档订单区域 */}
        {completedOrders.length > 0 && (
          <>
            <div style={{ 
              fontWeight: "900", 
              fontSize: "16px", 
              marginTop: "20px", 
              marginBottom: "10px", 
              borderBottom: "2px solid #ccc", 
              paddingBottom: "5px", 
              color: "#666" 
            }}>
              🗄️ 历史归档 ({completedOrders.length})
            </div>
            {completedOrders.slice().reverse().map(order => (
              <div key={order.id} style={{ 
                border: "3px solid #666", 
                background: "#eaeaea", 
                padding: "15px", 
                marginBottom: "15px", 
                position: "relative", 
                opacity: 0.9 
              }}>
                <div style={{ 
                  position: "absolute", 
                  top: "-12px", 
                  right: "-10px", 
                  background: "#000", 
                  color: "white", 
                  padding: "4px 12px", 
                  fontWeight: "900", 
                  border: "2px solid black", 
                  transform: "rotate(5deg)" 
                }}>
                  🎉 已交接
                </div>
                <div style={{ 
                  fontWeight: "900", 
                  fontSize: "16px", 
                  marginBottom: "8px", 
                  color: "#444" 
                }}>
                  历史单号：#{order.id}
                </div>
                <div style={{ 
                  fontSize: "13px", 
                  color: "#666", 
                  borderTop: "1px dashed #ccc", 
                  paddingTop: "8px", 
                  paddingBottom: "8px" 
                }}>
                  {order.items ? JSON.parse(order.items).map((item, i) => (
                    <div key={i}>• {item.name} x {item.quantity}</div>
                  )) : "数据"}
                </div>
                <div style={{ 
                  marginTop: "10px", 
                  background: "black", 
                  color: "white", 
                  padding: "12px", 
                  textAlign: "center", 
                  border: "2px solid #E6B422", 
                  borderRadius: "4px" 
                }}>
                  <div style={{ fontSize: "16px", fontWeight: "900", marginBottom: "4px" }}>
                    🎉 餐已完成，谢谢惠顾！
                  </div>
                  <div style={{ fontSize: "12px", color: "#E6B422", fontWeight: "bold" }}>
                    欢迎再次回到放克社区
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
        
        <button 
          onClick={onClearAllRecords} 
          style={{ 
            width: "100%", 
            marginTop: "15px", 
            background: "#ff5252", 
            color: "white", 
            padding: "12px", 
            border: "3px solid black", 
            fontWeight: "900", 
            cursor: "pointer", 
            boxShadow: "2px 2px 0 #000" 
          }}
        >
          💥 清空全服测试订单
        </button>
      </div>
    </div>
  );
};

export default OrderHistoryModal;
